enum LayoutTypes {
    MOBILE,
    TABLET,
    DESKTOP,
}

export default LayoutTypes;
